/*
 * @Author: your name
 * @Date: 2020-09-01 15:33:36
 * @LastEditTime: 2020-11-30 19:14:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmps-console-web/src/utils/language.js
 */
import zh from './zh-CN'
import en from './en-US'

const LANGUAGE_LIST = {
  'en-US': en,
  'zh-CN': zh
}

export default LANGUAGE_LIST
